import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const onBoardingOuterRoutes = [
  {
    path: routes.onBoardingOuterEmployee.employeeDetails,
    element: lazyLoadRoutes("employee-onboarding/add"),
  },
];
